module.exports = __webpack_public_path__ + "img/trash_can.b5b66ece.svg";